module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/127373191db953ce5e27630fda2ca80c.png";